import { browserWindowProvider } from './browser-window.provider';
import { windowProvider } from './window.provider';

export * from './window.factory';
export { WINDOW } from './window.provider';

export const WINDOW_PROVIDERS = [browserWindowProvider, windowProvider];
